import React from "react";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import BottomFloat2 from "../components/containers/BottomFloat2";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import t from "../Locale";
import classNames from "classnames";
import LastSecond from "../components/LastSecond";
import {
  computeAdd2,
  computeEmpty,
  computeSet,
} from "../redux/items/FourDCompute";
import Card4d from "../components/Card4d";
import { useState } from "react";
import { useEffect } from "react";
import { setPersonalDetails } from "../redux/items/PersonalDetails";
import FetchNoLogin from "../components/Fetch/FetchNoLogin";
import { compute4dTotal } from "../utils/functions";
import { Button, Dialog } from "@material-ui/core";
import FetchLogin from "../components/Fetch/FetchLogin";
// import dot from "dot-object";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Confirm from "../components/Confirm";

const PersonalDetails = () => {
  const hist = useHistory();
  const personalDetails = useSelector((state) => state.personalDetails);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login.user);
  const token = useSelector((state) => state.login?.token);
  const fourDCompute = useSelector((state) => state.fourDCompute);
  const settings = useSelector((state) => state.drawSet.set);

  const bottomRef = React.useRef(null);

  const [v, setV] = useState({
    name: "",
    email: "",
    error: "",
    dialogSaveWishList: false,
    nameWishList: "",
    errorSaveWishlist: "",

    dialogLoadWishList: false,
    wishList: [],

    dialogDeleteWishList: false,
    wishListId: 0,

    dialogUseWishList: false,
    wishListKey: 0,
  });

  const setV2 = (v2) => {
    setV((prev) => {
      let ret = { ...prev, ...v2 };
      // dot.object(ret);
      return ret;
    });
  };

  const reqPersonalDetails = FetchNoLogin("personal-details", {
    data: {
      name: v.name,
      email: v.email,
      token: token,
    },
    callbackInit: () => {
      setV2({ error: "" });
    },
    callback: (cb) => {
      if (cb.response.success) {
        dispatch(
          setPersonalDetails({
            name: v.name,
            email: v.email,
          })
        );
        setTimeout(() => {
          hist.push("/lottery-bet-slip");
        }, 0);
      } else {
        setV2({ error: cb.response.message });
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    },
  });

  const reqBetSave = FetchLogin("wishlist/four-d/save", {
    data: {
      token: token,
      name: v.nameWishList,
      bet: fourDCompute,
    },
    callbackInit: () => {
      setV2({ errorSaveWishlist: "" });
    },
    callback: (cb) => {
      if (cb.response.success)
        setV2({
          dialogSaveWishList: false,
          nameWishList: "",
          errorSaveWishlist: "",
        });
      else setV2({ errorSaveWishlist: cb.response.message });
    },
  });

  // const reqBetLoad = FetchLogin("wishlist/four-d/load", {
  //   data: {
  //     token: token,
  //   },
  //   callbackInit: () => {},
  //   callback: (cb) => {
  //     setV2({ dialogLoadWishList: true, wishList: cb.response.data.bets });
  //   },
  // });

  const reqBetDelete = FetchLogin("wishlist/four-d/delete", {
    data: {
      token: token,
      id: v.wishListId,
    },
    callbackInit: () => {},
    callback: (cb) => {
      setV2({ dialogDeleteWishList: false, wishList: cb.response.data.bets });
    },
  });

  useEffect(() => {
    setV2({ name: personalDetails.name, email: personalDetails.email });
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  return (
    <MainContainer
      render={
        <Grid container direction="column">
          <TopBar
            leftSide="/place-bet"
            title={t("Personal Details")}
            rightSide={
              <span
                style={{ cursor: "pointer", color: "red" }}
                onClick={() => {
                  dispatch(computeEmpty());
                }}
              >
                {t("Clear All")}
              </span>
            }
          />
        </Grid>
      }
      style={{ height: 85 }}
    >
      {/* <div style={{ textAlign: "center" }}>
        <Button
          onClick={() => reqBetLoad.handleTrigger()}
          style={{ padding: "8px 12px", fontSize: 16 }}
        >
          Wishlist
        </Button>
      </div> */}
      <div style={{ marginTop: 10 }}>
        <LastSecond />
      </div>
      <Card4d canDelete={true} />
      <Typography
        variant="h3"
        style={{
          textAlign: "center",
          fontSize: 24,
          color: "#6D6D6D",
          marginTop: 20,
          fontWeight: "bold",
        }}
      >
        {t("Personal Details")}
      </Typography>
      {user?.name === "" || user?.name === undefined || user?.name === null ? (
        <>
          <TextField
            fullWidth
            placeholder={t("Full Name")}
            className={classNames("pd-input", "personal-input")}
            value={v.name}
            onChange={(e) => setV2({ name: e.target.value })}
          />

          <TextField
            type="email"
            fullWidth
            placeholder={t("Email")}
            className={classNames("pd-input", "personal-input")}
            value={v.email}
            onChange={(e) => setV2({ email: e.target.value })}
            style={{ marginBottom: 16 }}
          />
        </>
      ) : (
        <div
          style={{
            fontSize: 18,
            width: "80%",
            margin: "0 auto",
            marginTop: 20,
          }}
        >
          <label>Name: </label>
          <b>{user?.name}</b>
          <br />

          {user?.email !== "" ? (
            <>
              <label>Email: </label>
              <b>{user?.email}</b>
              <br />
            </>
          ) : null}
        </div>
      )}
      <Typography
        dangerouslySetInnerHTML={{ __html: v.error }}
        style={{
          color: "red",
          textAlign: "center",
          paddingTop: 20,
          paddingBottom: 20,
        }}
      />
      <div ref={bottomRef} />

      <Dialog open={v.dialogLoadWishList} maxWidth="sm">
        <div style={{ padding: "24px 36px", textAlign: "center" }}>
          <h3
            style={{ fontFamily: "arial", textAlign: "center", fontSize: 28 }}
          >
            Wishlist Load Menu
          </h3>
          <div style={{ marginBottom: 20 }}>
            {v.wishList.length > 0 ? (
              <ul className="wishlist-list">
                {v.wishList.map((a, aI) => {
                  return (
                    <li key={aI}>
                      <DeleteIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          v.dialogDeleteWishList = setV2({
                            dialogDeleteWishList: true,
                            wishListId: a.id,
                          });
                        }}
                      />
                      <span>{a.name}</span>
                      <ArrowForwardIosIcon
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setV2({ dialogUseWishList: true, wishListKey: aI })
                        }
                      />
                    </li>
                  );
                })}
              </ul>
            ) : (
              <span>No Saved Wishlist</span>
            )}
          </div>
          <Button
            style={{ fontSize: 12, padding: "8px 12px", background: "red" }}
            onClick={() => {
              setV2({ dialogLoadWishList: false });
            }}
          >
            Close
          </Button>
        </div>
      </Dialog>

      <Dialog open={v.dialogSaveWishList} maxWidth="sm">
        <div style={{ padding: "24px 36px", textAlign: "center" }}>
          <h3
            style={{ fontFamily: "arial", textAlign: "center", fontSize: 28 }}
          >
            Wishlist Save Menu
          </h3>
          <div style={{ marginBottom: 20 }}>
            <TextField
              placeholder="Wishlist Name"
              onChange={(event) => setV2({ nameWishList: event.target.value })}
              value={v.nameWishList}
            />
          </div>
          <Button
            style={{ fontSize: 24 }}
            onClick={() => reqBetSave.handleTrigger()}
          >
            Save
          </Button>{" "}
          <br />
          <span style={{ color: "red", display: "block", marginTop: 10 }}>
            {v.errorSaveWishlist}
          </span>
          <br />
          <Button
            style={{ fontSize: 12, padding: "8px 12px", background: "red" }}
            onClick={() => setV2({ dialogSaveWishList: false })}
          >
            Close
          </Button>
        </div>
      </Dialog>

      <Confirm
        open={v.dialogDeleteWishList}
        onClose={() => setV2({ dialogDeleteWishList: false })}
        question="Are you Sure? You want to Delete this"
        choices={[
          {
            title: "Confirm",
            onClick: () => {
              reqBetDelete.handleTrigger();
            },
          },
        ]}
      />

      <Confirm
        open={v.dialogUseWishList}
        onClose={() => setV2({ dialogUseWishList: false })}
        question="Add on Existing or Remove Others?"
        choice="3"
        choices={[
          {
            title: "Add on Existing",
            onClick: () => {
              let bets = v.wishList[v.wishListKey].bets;
              setV2({ dialogUseWishList: false, dialogLoadWishList: false });
              dispatch(computeAdd2(bets));
            },
          },
          {
            title: "Only This",
            onClick: () => {
              let bets = v.wishList[v.wishListKey].bets;
              setV2({ dialogUseWishList: false, dialogLoadWishList: false });
              dispatch(computeSet(bets));
            },
          },
        ]}
      />

      <BottomFloat2
        total={compute4dTotal(fourDCompute, settings)}
        title={"Next"}
        wishListActive={true}
        wishListClick={() => setV2({ dialogSaveWishList: true })}
        onClick={() => {
          if (
            user?.name === "" ||
            user?.name === undefined ||
            user?.name === null
          )
            reqPersonalDetails.handleTrigger();
          else hist.push("/lottery-bet-slip");
        }}
      />
    </MainContainer>
  );
};

export default PersonalDetails;
